import React, { Component } from 'react';
import classNames from 'classnames/bind';
import axios from 'axios';

import {
  Button,
  Link,
  I18n,
  Status,
  Heading,
  Checkbox,
  Popup,
} from 'components';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export class AgreementRenewalRequest extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    axios.get('/api/profile/homeinternet/renewalagreement/')
      .then(({ data }) => this.setState(data))
      .catch((error) => error);
  }

  toggleAgreementPopup = () => this.setState((prevState) => ({
    isAgreementVisible: !prevState.isAgreementVisible,
  }));

  sendConfirmation = async (isConfirm) => {
    const { reqExternalId, offerStatus } = this.state;

    try {
      const { data } = await axios.post('/api/profile/homeinternet/confirmRenewal', {
        reqExternalId, isConfirm, offerStatus,
      });

      if (data) {
        this.setState({ isSuccess: true });
      } else {
        this.setState({ isError: true });
      }
    } catch (error) {
      this.setState({ isError: true });
    }
  }

  render() {
    const {
      agreementNumber,
      newOwnerName,
      officeUrl,
      offerText,
      offerStatus,
      isAgreementVisible,
      isSuccess,
      isError,
    } = this.state;

    if (!agreementNumber) return null;

    if (isSuccess) {
      return (
        <Status className={['success', cx('component')]}>
          {offerStatus === 'Y' ? (
            <I18n
              path="internet.agreementRenewal.successConfirm"
              vars={{ name: newOwnerName }}
            />
          ) : (
            <I18n
              path="internet.agreementRenewal.successRefuse"
              vars={{ name: newOwnerName }}
            />
          )}
        </Status>
      );
    }

    if (isError) {
      return (
        <Status className={['error', cx('component')]} emoji="statusFail">
          <I18n path="common.operationFailed" />
          {'. '}
          <Link onClick={() => this.setState({ isError: false })}>
            <I18n path="common.retry" />
          </Link>
        </Status>
      );
    }

    return (
      <>
        <Status
          className={['attention', cx('component')]}
          emoji="statusFail"
        >
          <div className={cx('row')}>
            <I18n
              path="internet.agreementRenewal.message"
              vars={{
                number: agreementNumber,
                name: newOwnerName,
                offices: (
                  <Link key="link" href={officeUrl} target="_blank">
                    офис
                  </Link>
                ),
              }}
            />
          </div>

          <div className={cx('row')}>
            <Checkbox
              className={cx('checkbox')}
              checked={offerStatus === 'Y'}
              handleChange={() => this.setState({
                offerStatus: offerStatus === 'Y' ? 'N' : 'Y',
              })}
            >
              <I18n
                path="internet.agreementRenewal.agreement"
                vars={{
                  agreement: (
                    <Link key="link" onClick={this.toggleAgreementPopup}>
                      согласие
                    </Link>
                  ),
                  number: agreementNumber,
                }}
              />
            </Checkbox>
          </div>

          <div className={cx('row')}>
            <Button
              className={cx('button')}
              onClick={() => this.sendConfirmation(true)}
              disabled={offerStatus !== 'Y'}
            >
              <I18n path="common.confirm" />
            </Button>
            <Button
              className={['default', cx('button')]}
              onClick={() => this.sendConfirmation(false)}
              disabled={offerStatus === 'Y'}
            >
              <I18n path="common.refuse" />
            </Button>
          </div>

          <div className={cx('row')}>
            <I18n path="internet.agreementRenewal.support" />
          </div>
        </Status>

        {isAgreementVisible && (
          <Popup
            onClose={this.toggleAgreementPopup}
            opened
          >
            <Heading level={1}>
              Условия оферты
            </Heading>
            <div
              className={cx('offerText')}
              dangerouslySetInnerHTML={{ __html: offerText }}
            />
          </Popup>
        )}
      </>
    );
  }
}
